"use client";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

const ProductRelatedLoader = ({
    children,
}: {
    children?: React.ReactNode;
}) => {
    const { hasMouseMoved } = useMouseMovement();

    return <>{hasMouseMoved && children}</>;
};

export default ProductRelatedLoader;
